import { useEffect } from "react";
import { useInstrument } from "../contexts/InstrumentContext";
import { useWorkbench } from "../components/layout/WorkbenchLayout";

/**
 * UI espaciosa: en teclado, canvas amplio + dock inferior + inspector derecho abierto.
 * En mástil, inspector colapsado al entrar (expandible).
 */
export function useSpaciousWorkbench() {
  const { surface } = useInstrument();
  const { setRightCollapsed, setLeftCollapsed, setBottomCollapsed } = useWorkbench();

  useEffect(() => {
    if (surface === "keyboard") {
      setRightCollapsed(false);
      setLeftCollapsed(true);
      setBottomCollapsed(false);
    } else {
      setRightCollapsed(true);
    }
  }, [surface, setRightCollapsed, setLeftCollapsed, setBottomCollapsed]);

  return {
    surface,
    hideInspector: surface === "keyboard",
    useBottomDock: surface === "keyboard",
  };
}
